import { IPagination } from '@/core/interfaces/pagination.interface';
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import { PaperTypeItem } from '../models/paper-type-item.model';
import { TemplatesService } from '../services/templates.service';
import { TEMPLATES_MUTATIONS, TEMPLATES_PAGE_SIZE, TEMPLATES_SCOPE, TEMPLATES_TYPES, _TEMPLATES_STORE } from '../values/templates.values';

export const TEMPLATES_STORE = _TEMPLATES_STORE;

@Module({ namespaced: true })
export class TemplatesStore extends VuexModule {

  /* State */
  public eduacPapers: IPagination = {
    page: 0, more: true, content: [], load: false
  };

  public userPapers: IPagination = {
    page: 0, more: true, content: [], load: false
  };

  public paperSelected: PaperTypeItem = null;

  /* Mutations */
  @Mutation
  public setEduacPapers(data: any) {
    this.eduacPapers.load = true;
    this.eduacPapers.content = data.content.map(pp => {
      return new PaperTypeItem(pp.templateId, pp.name, pp.assetImageInfo.url, pp.assetDataInfo.url);
    });
    this.eduacPapers.page++;
    this.eduacPapers.more = data.totalPages > this.eduacPapers.page;
  }

  @Mutation
  public setUserPapers(data: any) {
    this.userPapers.load = true;
    this.userPapers.content = data.content.map(pp => {
      return new PaperTypeItem(pp.templateId, pp.name, pp.assetImageInfo.url, pp.assetDataInfo.url);
    });
    this.userPapers.page++;
    this.userPapers.more = data.totalPages > this.userPapers.page;
  }

  @Mutation
  public addUserPapers(paperTypeItem: PaperTypeItem) {
    this.userPapers.content.push(paperTypeItem);
  }

  @Mutation
  public setUserPaperSelected(templateId) {
    this.userPapers.content.forEach((pp) => {
      pp.selected = pp.templateId == templateId;
      this.paperSelected = pp.templateId == templateId ? pp : this.paperSelected;
    });
    if(!templateId) this.paperSelected = null;
  } 

  @Mutation
  public setEduacPaperSelected(templateId) {
    this.eduacPapers.content.forEach((pp) => {
      pp.selected = pp.templateId == templateId;
      this.paperSelected = pp.templateId == templateId ? pp : this.paperSelected;
    });
    if(!templateId) this.paperSelected = null;
  } 

  @Mutation
  public clearPaperSelected() {
    this.paperSelected = null;
  }

  @Mutation
  public resetUserPapersLoad() {
    this.userPapers.load = false;
    this.userPapers.page = 0;
    this.userPapers.more = true;
    this.userPapers.content = [];
  }

  @Action({rawError: true})
  public getEduacPpapers(): Promise<void> {
    return new Promise((resolve, reject) => {
      TemplatesService.searchTemplates(
        this.eduacPapers.page,
        TEMPLATES_PAGE_SIZE,
        TEMPLATES_TYPES.PP,
        TEMPLATES_SCOPE.PUBLIC
      ).then((res) => {
        this.context.commit(TEMPLATES_MUTATIONS.SET_EDUAC_PAPERS, res);
        resolve();
      }).catch(err => {
        reject(err);
      });
    }); 
  }

  @Action({rawError: true})
  public getUserPapers(): Promise<void> {
    return new Promise((resolve, reject) => {
      TemplatesService.searchTemplates(
        this.userPapers.page,
        TEMPLATES_PAGE_SIZE,
        TEMPLATES_TYPES.PP,
        TEMPLATES_SCOPE.PRIVATE
      ).then((res) => {
        this.context.commit(TEMPLATES_MUTATIONS.SET_USER_PAPERS, res);
        resolve();
      }).catch(err => {
        reject(err);
      });
    }); 
  }

  /* Initial State */
  @Mutation
  public initState(state) {
    this.eduacPapers = {
      page: 0, more: true, content: [], load: false
    };
    this.userPapers = {
      page: 0, more: true, content: [], load: false
    };
    this.paperSelected = null;
  }

}